import React from "react";
import loader from "../../Assets/Images/Components/Other/loader.gif";
export default function Loader() {
  return (
    <div className=" d-flex justify-content-center align-items-center h-lg-134 w-100">
      <img className="img-fluid" src={loader} width={58} height={58} alt="Loading" />
    </div>
  );
}
